<template>
  <div class="CIT_background">
    <div
      v-if="loading"
      class="d-flex vertical-center justify-content-center align-items-center"
      style="height: 85vh; display: flex"
    >
      <LoadingMDL />
    </div>
    <div v-else class="position" style="display: flex; flex-direction: column">
      <div class="bg-image"></div>
      <div class="blur_bg">
        <div class="container_CIT02">
          <div class="block">
            <div
              v-if="videoLink == ''"
              class="d-flex vertical-center justify-content-center align-items-center"
            >
              <LoadingMDL />
            </div>
            <div v-else>
              <div class="text_completed_container">
                <a class="text_completed text-center">TEST COMPLETE</a>
              </div>
              <video width="90%" autoplay loop muted class="video_class">
                <source :src="videoLink" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
        <CRow
          style="
            display: flex;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
          "
        >
          <div
            class="button button_setting"
            @click="nextRoute(content.navigate)"
          >
            <CCol col="12">
              <div style="font-size: 18px; padding: 0px 1px 0px 1px">NEXT</div>
            </CCol>
          </div>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/signInCss/Button.vue';
import Card from '@/components/elements/Card.vue';
import {mapGetters} from 'vuex';
import TEMPLATE from '../../../TEMPLATE.vue';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  components: {Button, Card, TEMPLATE, LoadingMDL},
  name: 'LKI02',
  props: {},
  data() {
    return {
      content: {},
      baseUrl: process.env.VUE_APP_URL_SOUND,
      currentRoute: '',
      loading: true,
      content: [],
      videoLink: '',
      condition: [],
      templateData: [],
      startTime: this.$helpers.getDateFormat(),
      navigate: [],
      sound: {},
      showScore: 0,
    };
  },
  methods: {
    onLoadData() {
      this.loading = true;
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    nextRoute: function () {
      this.loading = true;
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);

      const str = this.navigate.next.action.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;

      this.$router.push(path);

      // this.$store.dispatch('template/commitUserProgressChinese2', {
      //   // code: "605418cb883ae722ba1b0c5f",
      //   code: this.code,
      //   codeTemplate: this.templateData.templateData.codeTemplate,
      //   contentId: this.templateData.criteria._id,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      //   chapter:
      //     this.templateData.chapter == undefined
      //       ? null
      //       : this.templateData.chapter,

      //   topic: this.templateData.topicPosition,
      // });
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      getTemplatev3: 'v3/getTemplates',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];

      this.navigate = template.navigate;

      this.content = template;

      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: val.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: val.content,
          type: val.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          enable: true,
          score: 0,
          maxScore: 0,
        },
      ];
      //
      //
      this.$store.dispatch('v3/saveScoreAndProgress', payload);
      console.log('run');

      this.loading = false;
    },
    saveScoreAndProgress: async function (value) {
      console.log('Life cycle...Watch', value);

      if (value.length == 0) {
        return console.log('No data is call');
      }

      value = value[0];

      let userScore = String(value.totalScore).padStart(2, '0');
      let maxScore = String(value.maxScore).padStart(2, '0');
      this.score = userScore + '/' + maxScore;
      this.showScore = value.totalScore;
    },
    showScore(val) {
      let score = val || 0;
      if (score < 5) {
        this.sound = new Audio(
          'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Bad%20Soudtrack/multimedia_game_sound_synth_tone_bold_fail_52993.mp3'
        );
      } else if (score >= 5) {
        this.sound = new Audio(
          'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Good%20Sound%20Effect/cartoon_success_fanfair.mp3'
        );
      }

      let displayConditionArray = this.content.content.item;
      for (let i = 0; i < displayConditionArray.length; i++) {
        if (
          score >= displayConditionArray[i].choices.score &&
          score <= displayConditionArray[i].choices.max_score
        ) {
          this.videoLink =
            this.baseUrl + '' + displayConditionArray[i].media.url;
        }
      }
      this.sound.play();
    },
    // getTemplateAndProgress: async function (value) {
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   let score = value.calcualteScore.score;
    //   if (score < 5) {
    //     this.sound = new Audio(
    //       'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Bad%20Soudtrack/multimedia_game_sound_synth_tone_bold_fail_52993.mp3'
    //     );
    //   } else if (score >= 5) {
    //     this.sound = new Audio(
    //       'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Good%20Sound%20Effect/cartoon_success_fanfair.mp3'
    //     );
    //   }
    //   let displayConditionArray = value.templateData.content.item;
    //   for (let i = 0; i < displayConditionArray.length; i++) {
    //     if (
    //       score >= displayConditionArray[i].choices.score &&
    //       score <= displayConditionArray[i].choices.max_score
    //     ) {
    //       this.videoLink =
    //         this.baseUrl + '' + displayConditionArray[i].media.url;
    //     }
    //   }
    //   this.navigate = value.templateData.navigate;
    //   this.templateData = value;
    //   this.content = value.templateData;
    //   this.loading = false;
    //   this.sound.play();
    // },
    // getResponseStatus: async function (value) {
    //   if (value.status == 200) {
    //     let route = this.navigate.next.action.split('-');
    //     this.$router.push('/' + route[0] + '/' + route[1]);
    //   }
    // },
  },
  created() {},
  mounted() {
    // let payload = {
    //   templateCode: this.currentRoute,
    //   // code: "605418cb883ae722ba1b0c5f",
    //   code: this.code,
    //   // section: "testing",
    //   section: this.section,
    //   calculate_score: true,
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  display: flex;
  align-content: center;
  justify-content: center;
}
.block {
  width: 650px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}
.card {
  width: 400px;
  height: 400px;
  border-radius: 10px; /* 5px rounded corners */
  border: 2px solid;
  margin: 0;
  display: flex;
  justify-content: center;
}
.container_CIT02 {
  margin-left: auto;
  margin-right: auto;
}
.text_completed {
  font-size: 36px;
  color: #fe9774;
}
.text_completed_container {
  margin-top: 20px;
  margin-bottom: 15px;
}
.button_setting {
  background-color: #89abe6;
  width: 40%;
  height: 60px;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 7px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 50%;
}
.bg-image {
  background-image: linear-gradient(90deg, #ffdc77 0%, #fff 50%, #ffccd5 100%);
  filter: blur(1px);
  -webkit-filter: blur(1px);
  height: 1080px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.video_class {
  margin-bottom: 25px;
}
.blur_bg {
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  z-index: 2;
  text-align: center;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .block {
    width: 300px;
    height: auto;
    margin-top: 1%;
  }
  .video_class {
    margin-bottom: 10px;
  }
  .card {
    width: 200px;
    height: 200px;
  }
  .btn-prev {
    width: 50px;
    height: 50px;
    padding: 10px;
    right: 102%;
  }
  .bg-image {
    height: 700px;
  }
  .button_setting {
    width: 130px;
    height: 45px;
  }
  .text_completed_container {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .text_completed {
    font-size: 20px;
    color: #fe9774;
  }
  .blur_bg {
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%);
    z-index: 2;
    text-align: center;
  }
}
</style>
